<template>
    <div class="timeline">
        <p-header :title="title" :showClose="isFullMap" @onClose="isFullMap = false"/>
        <GmapMap
                :style="mapClass"
                :options="{
                   zoomControl: true,
                   mapTypeControl: false,
                   scaleControl: false,
                   streetViewControl: false,
                   rotateControl: false,
                   fullscreenControl: false,
                   disableDefaultUI: false,
                   clickableIcons: false,
                   zoomControlOptions: {
                        position: 3,
                   },
                   styles: [
                       {
                           featureType: 'poi',
                           stylers: [
                               {
                                   visibility: 'off'
                               }
                           ]
                       },
                       {
                           featureType: 'transit',
                           elementType: 'labels.icon',
                           stylers: [
                               {
                                   visibility: 'off'
                               }
                           ]
                       }
                   ],
                   maxZoom: 18,
                 }"
                :center="center"
                :zoom="14"
                @click="clickMap"
                map-type-id="roadmap"
                ref="map">
            <GmapMarker
                    :key="index"
                    v-for="(m, index) in locations"
                    :position="{lat: m.latitude, lng: m.longitude}"
                    :clickable="false"
                    :animation="2"
                    :label="{text:(index + 1).toString(), color: '#fff'}"
                    :icon="{
                        url: m.left_at || (locations[index - 1] && !locations[index - 1].left_at) ? require('@/assets/img/map/location.svg') : require('@/assets/img/map/location-green.svg'),
                        origin: {x:0, y:0},
                        labelOrigin: {x:12,y:13},
                        fontFamily: 600,
                    }"
                    @click="center={lat: m.latitude, lng: m.longitude}"/>
            <GmapMarker
                    v-if="driverPosition && !isWaitGoLocation"
                    key="driver"
                    :position="driverPosition"
                    :clickable="false"
                    :animation="2"
                    :icon="{
                        url: require('@/assets/img/map/moto.svg'),
                        origin: {x:0, y:0},
                        labelOrigin: {x:12,y:13},
                        fontFamily: 600,
                    }"
                    :zIndex="1"
                    @click="center=driverPosition"/>
        </GmapMap>
        <div class="times" v-show="!isFullMap" ref="times">
            <div class="line" :style="lineStyle"/>
            <div class="time now pig" v-show="isDispatching">
                <div class="glow"/>
                <div class="task">
                    <div class="content">
                        <div class="status">
                            {{ '配對中' }}
                        </div>
                        <div class="description">
                            若配對失敗，將於 {{ lastDispatched }} 暫停配對

                            <div v-if="isTransfer">
                                <br>
                                您好：原先任務騎士因故執行異常無法前往，平台為您重新配對新的騎士執行任務。
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="time done" v-show="isDoneDispatch">
                <div class="glow"/>
                <div class="task">
                    <div class="content">
                        <div class="status">
                            成功配對
                        </div>
                        <div class="description">
                            {{ acceptedAt }} 已為您找到騎士
                        </div>
                    </div>
                </div>
            </div>
            <div class="time now" v-show="isWaitGoLocation">
                <div class="glow"/>
                <div class="task">
                    <div class="content">
                        <div class="status">
                            <img src="@/assets/img/success.svg" alt="success">
                            預約成功
                        </div>
                        <div class="description">{{ acceptedAt }} 已為您找到騎士</div>
                    </div>
                </div>
            </div>
            <div class="time now err" v-show="isMissing">
                <div class="glow"/>
                <div class="task">
                    <div class="content">
                        <div class="status">
                            <img src="@/assets/img/error.svg" alt="err">
                            配對失敗
                        </div>
                        <div class="description">
                            請重新配對或加速配對
                        </div>
                    </div>
                </div>
            </div>
            <p-time v-for="(location, index) in locations" :key="location.id" :location="location" :locations="locations" :location-index="index" :order="order" :is-wait-go-location="isWaitGoLocation"/>
        </div>
        <div class="bottom" v-show="isMobile">
            <div class="buttons">
                <div class="button" @click="download">
                    <img src="@/assets/img/download.svg">
                    下載App
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import header from './components/Header';
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import time from './components/Timeline/Time';
    import * as apis from '../apis';

    export default {
        name: 'Share',
        components: {
            'p-header': header,
            'p-time': time,
        },
        data() {
            return {
                lineStyle: {
                    'height': '0px',
                },
                isLoaded: false,
                center: {lat:25.047846061048485, lng:121.5169639353331},
                timeout: null,
                driverPosition: null,
                isFullMap: false,
                isTransfer: false,
                order: {},
                code: null,
            }
        },
        computed: {
            isMobile() {
                if(! /AppleWebKit.*Mobile/i.test(navigator.userAgent) &&
                    ! /MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(navigator.userAgent) &&
                    ! /Android|webOS|iPhone|iPod|BlackBerry|iPad/i.test(navigator.userAgent)){
                    return false;
                }

                return true;
            },
            isDispatching() {
                return this.order.status === 'dispatching' || this.order.status === 'sending';
            },
            isDoneDispatch() {
                return this.order.status === 'processing' && (! this.order.reserved_at || this.locations[0].arrived_at);
            },
            isWaitGoLocation() {
                return this.order.status === 'processing' && this.order.reserved_at && ! this.locations[0].arrived_at;
            },
            isMissing() {
                return this.order.status === 'missing';
            },
            title() {
                return `任務編號 #${this.order.id}`;
            },
            locations() {
                return this.order.locations || [];
            },
            acceptedAt() {
                if (! this.order.accepted_at) {
                    return '';
                }

                let time = moment(this.order.accepted_at);

                return time.isSame(moment(), 'day') ? time.format('HH:mm') : time.format('MM/DD HH:mm')
            },
            lastDispatched() {
                if (! this.order.sent_at) {
                    return '';
                }

                let time = moment(this.order.sent_at).add(60, "minutes");

                return time.format('MM/DD HH:mm');
            },
            mapClass() {
                if (! this.isFullMap) return {
                    height: '200px',
                    width: '100%',
                    border: '1px solid #979797',
                    'border-radius': '0 0 5px 5px',
                    'background-color': '#D8D8D8',
                    'box-shadow': '0 0 4px 0 rgba(0,0,0,0.35)',
                    'box-sizing': 'border-box',
                };

                return {
                    position: 'absolute',
                    top: '52px',
                    bottom: '0px',
                    height: 'auto',
                    width: '100%',
                }
            },
            ...mapGetters(['getIsLaunch'])
        },
        methods: {
            clickMap() {
                this.isFullMap = true;
            },
            initTimeline() {
                this.$nextTick(() => {
                    this.lineStyle.height =
                        this.$refs.times.lastChild.getBoundingClientRect().top
                        - this.$refs.times.firstChild.getBoundingClientRect().top + 20
                        + 'px';
                })
            },
            updateMapBounds() {
                if (!this.$refs.map) {
                    return;
                }

                const bounds = new google.maps.LatLngBounds()
                if (this.driverPosition && !this.isWaitGoLocation) {
                    bounds.extend(this.driverPosition);
                    let location = this.locations.find(location => !location.left_at)
                    if (location) bounds.extend({lat: location.latitude, lng: location.longitude});
                } else {
                    for (let m of this.locations) {
                        bounds.extend({lat: m.latitude, lng: m.longitude});
                    }
                }

                this.$refs.map.fitBounds(bounds);
            },
            updateDriverPosition() {
                apis.getSharePosition(this.code).then(res => {
                    if (res.data.status === 'ok' && (this.driverPosition == null || (this.driverPosition.lat != res.data.position.lat && this.driverPosition.lng != res.data.position.lng))) {
                        this.driverPosition = res.data.position;
                        this.updateMapBounds();
                    }
                });
            },
            checkOrderStatus() {
                if (this.order.status !== 'processing' &&
                    this.order.status !== 'dispatching' &&
                    this.order.status !== 'appointing' &&
                    this.order.status !== 'missing' &&
                    this.order.status !== 'sending') {
                    this.$router.replace({
                        name: 'shareFail',
                    })
                }
            },
            getOrder() {
                return apis.getShareOrder(this.code).then(res => {
                    this.order = res.data;
                    this.updateMapBounds();
                    this.initTimeline();
                    this.updateDriverPosition();
                    this.checkOrderStatus();

                    return res.data;
                }).catch(() => {
                    this.$router.replace({
                        name: 'shareFail',
                    })
                });
            },
            transferOrder(event) {
                if (!event.hasOwnProperty('old_share_code') || !event.hasOwnProperty('new_share_code')) {
                    return;
                }

                this.$router.replace({
                    name: 'share',
                    params: {
                        code: event.new_share_code,
                    },
                    query: {
                        transfer: 1,
                    }
                })
            },
            download() {
                if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                    window.open('https://apps.apple.com/tw/app/id1470204005', "_blank");
                } else if (/(Android)/i.test(navigator.userAgent)) {
                    window.open('https://play.google.com/store/apps/details?id=tw.com.paopaotui.consumer', "_blank");
                } else {
                    window.open('https://paopaotui.com.tw/', "_blank");
                };
            }
        },
        created() {
            this.code = this.$route.params.code;
            this.isTransfer = this.$route.query.transfer;
            this.getOrder().then(() => {
                this.timeout = setInterval(() => {
                    this.updateDriverPosition();
                }, 10 * 1000);

                this.$echo.channel('share.order.' + this.code)
                    .listen('OrderStatusChanged', e => this.getOrder())
                    .listen('LocationArrived', e => this.getOrder())
                    .listen('LocationLeft', e => this.getOrder())
                    .listen('OrderDone', e => this.getOrder())
                    .listen('OrderTransferred', e => this.transferOrder(e));
            });
        },
        beforeDestroy() {
            if (this.timeout) {
                clearInterval(this.timeout);
            }

            if (this.code) {
                this.$echo.leave('share.order.' + this.code);
            }
        },
        watch: {
            getIsLaunch() {
                this.initTimeline();
            }
        }
    };
</script>

<style lang="scss" scoped>
    .pig {
        position: relative;

        .pig-tail {
            position: absolute;
            color: #4A90E2;
            right: 6px;
            bottom: -20px;
            font-size: 12px;
            font-weight: 500;
        }
    }


    .timeline {
        position: relative;
        flex: 1;

        .tip {
            color: #9B9B9B;
            font-size: 13px;
            line-height: 18px;
            display: flex;
            align-items: center;
            margin-left: 50px;
            position: relative;

            &::after {
                content: url('~@/assets/img/moto-line.svg');
                position: absolute;
                top: 9px;
                left: -21px;
            }
        }

        .times {
            margin: 13px 20px 10px 30px;
            padding-bottom: 180px;

            .line {
                width: 1px;
                background-color: #D8D8D8;
                position: absolute;
                margin-left: 6px;
                margin-top: 20px;
            }

            .time {
                user-select: none;
                display: flex;
                margin-top: 10px;
                min-height: 65px;

                .glow {
                    margin-top: 15px;
                    border-radius: 90px;
                    position: relative;
                }

                .task {
                    margin-left: 20px;
                    flex: 1;
                    display: flex;
                    padding: 10px 15px;
                    justify-content: space-between;
                    align-items: center;

                    .content {
                        text-align: left;

                        .status {
                            font-size: 14px;
                            font-weight: 600;
                            display: flex;
                            align-items: center;
                        }

                        .description {
                            font-size: 12px;
                            margin-top: 8px;
                        }
                    }

                    .buttons {
                        .button {
                            background-color: #4a4a4a;
                            border-radius: 12.5px;
                            padding: 3px 10px;
                            font-size: 14px;
                            cursor: pointer;
                            white-space: nowrap;
                        }
                    }
                }
            }
        }

        .err {
            color: #FFFFFF;

            .glow {
                background-color: #F44336 !important;
                box-shadow: 0 0 5px rgba(244,67,54,.2) !important;

                &::after {
                    background-color: rgba(244,67,54,.45) !important;
                }

                &::before {
                    background-color: rgba(244,67,54,.2) !important;
                }
            }

            .task {
                background-color: #F44336 !important;

                .buttons {
                    .button {
                        background-color: #4A4A4A !important;
                    }
                }
            }
        }

        .now {
            color: #FFFFFF;

            .glow {
                width: 12px;
                height: 12px;
                background-color: #339933;
                border-radius: 90px;
                box-shadow: 0 0 5px rgba(0,255,0,.2);
                animation: glow-1 800ms ease-out infinite alternate;

                &::after {
                    content: '';
                    top: 0;
                    left: 0;
                    position:absolute;
                    width:12px;
                    height: 12px;
                    border-radius: 90px;
                    background-color: rgba(51,153,51,.45);
                    animation: glow-2 800ms ease-out infinite alternate;
                }

                &::before {
                    content: '';
                    top: 0;
                    left: 0;
                    position:absolute;
                    width:12px;
                    height: 12px;
                    border-radius: 90px;
                    background-color: rgba(51,153,51,.2);
                    animation: glow-3 800ms ease-out infinite alternate;
                }
            }

            .task {
                background-color: #4A90E2;
                border-radius: 5px;

                &.green {
                    background-color: #339933;
                }
            }
        }

        .wait {
            .glow {
                margin-left: -3px;
                width: 18px;
                height: 18px;
                background-color: #D8D8D8;
            }

            .task {
                .content {
                    .description {
                        color: #9b9b9b;
                    }
                }
            }
        }

        .done {
            .task {
                color: #9B9B9B;
            }

            .glow {
                margin-left: -3px;
                width: 18px;
                height: 18px;
                background-color: #fff;

                &::after {
                    content: '';
                    top: 0;
                    left: 0;
                    position: absolute;
                    width: 18px;
                    height: 18px;
                    border-radius: 90px;
                    background-color: rgba(51,153,51, .4);
                }

                &::before {
                    content: "";
                    position: absolute;
                    width: 5px;
                    height: 9px;
                    border-bottom: 2px solid #fff;
                    border-right: 2px solid #fff;
                    transform: rotate(45deg);
                    z-index: 10;
                    top: 2px;
                    left: 6px;
                }
            }
        }

        .last {
            .glow {
                &::after {
                    content: '終點';
                    height: 16px;
                    color: #9B9B9B;
                    font-size: 11px;
                    position: absolute;
                    left: -3px;
                    bottom: -18px;
                    width: 25px;
                }
            }
        }

        .bottom {
            position: absolute;
            bottom: 0;
            width: calc(100% - 30px);
            margin: 15px;

            .buttons {
                margin-top: 15px;
                cursor: pointer;
                user-select: none;

                .button {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 45px;
                    background-color: #339933;
                    color: #FFFFFF;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 23px;
                    text-align: center;
                    font-weight: 500;
                    border-radius: 35px;

                    img {
                        margin-right: 5px;
                    }
                }
            }

            .order {
                background-color: #ffffff;
                border-radius: 5px;
                box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
                color: #4A4A4A;
                font-size: 13px;
                padding: 15px;
                box-sizing: border-box;

                .sum {
                    color: #000000;
                    font-size: 16px;

                    .title {
                        display: flex;
                        align-items: center;
                        img {
                            width: 28px;
                            margin-right: 5px;
                        }
                    }
                }

                .prepaid, .sum, .expected {
                    display: flex;
                    justify-content: space-between;
                    padding: 3px;

                    span {
                        color: #9B9B9B;
                        font-size: 12px;
                        margin-right: 5px;
                    }
                }

                .detail {
                    color: #339933;
                    font-size: 14px;
                    font-weight: 600;
                    display: flex;
                    align-content: center;
                    justify-content: flex-end;
                    margin-top: 10px;

                    img {
                        height: 20px;
                        width: 20px;
                    }
                }
            }
        }
    }

    @keyframes glow-3 {
        0% {
            transform: scale(1);
        }

        100% {
            transform: scale(2);
        }
    }

    @keyframes glow-2 {
        0% {
            transform: scale(1);
        }

        100% {
            transform: scale(1.6);
        }
    }

    @keyframes glow-1 {
        0% {
            transform:scale(1);
        }
        100% {
            transform:scale(1.2);
        }
    }
</style>
